"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _reactFeather = require("react-feather");

var _react2 = require("@emotion/react");

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _ = require("..");

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Select = function Select(_ref) {
  var className = _ref.className,
      children = _ref.children,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "regular" : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange;
  var paddingY = _theme["default"].spaceThreeQuarters;
  var paddingX = _theme["default"].spaceOne;
  var fontSize = _theme["default"].fontSizeN;

  if (size === "small") {
    fontSize = _theme["default"].fontSizeM;
    paddingY = _theme["default"].spaceHalf;
    paddingX = _theme["default"].spaceHalf;
  }

  if (size === "big") {
    fontSize = _theme["default"].fontSizeL;
    paddingY = _theme["default"].spaceOne;
    paddingX = _theme["default"].spaceOneAndHalf;
  }

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      _value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(e) {
    var newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  return (0, _react2.jsx)("div", {
    css: (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        position: relative;\n        width: 100%;\n\n        font-size: ", ";\n      "])), fontSize)
  }, (0, _react2.jsx)("select", {
    className: className,
    id: id,
    name: name,
    value: _value,
    onChange: handleChange,
    disabled: disabled,
    css: (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          appearance: none;\n\n          box-sizing: border-box;\n\n          width: 100%;\n          height: calc(\n            ", " * 2 + ", " * ", " + 2 *\n              ", "\n          );\n          padding: ", " ", ";\n\n          border: ", " solid ", ";\n          border-radius: ", ";\n\n          background: ", ";\n          color: ", ";\n\n          white-space: nowrap;\n          font-family: ", ";\n          font-size: inherit;\n          line-height: ", ";\n\n          cursor: pointer;\n          transition: all 0.15s;\n\n          ", "\n\n          ", "\n        }\n      "])), paddingY, fontSize, _theme["default"].lineHeightN, _theme["default"].borderSizeRegular, paddingY, paddingX, _theme["default"].borderSizeRegular, _theme["default"].colorDarkTemp, _theme["default"].radiusRegular, _theme["default"].colorLightTemp, _theme["default"].colorDarkTemp, _theme["default"].fontFamily, _theme["default"].lineHeightN, !disabled && "\n            @media (hover: hover) {\n              &:hover {\n                filter: brightness(1.2);\n              }\n            }\n            ", disabled && "\n            cursor: default;\n            opacity: 0.5;\n            ")
  }, children), (0, _react2.jsx)("span", {
    css: (0, _react2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          position: absolute;\n          top: calc(50% + ", ");\n          right: ", ";\n\n          transform: translateY(-50%);\n          pointer-events: none;\n\n          ", "\n        "])), _theme["default"].spaceEighth, paddingX, disabled && "\n          opacity: 0.5;\n          ")
  }, (0, _react2.jsx)(_.Icon, {
    size: "inherit"
  }, (0, _react2.jsx)(_reactFeather.ChevronDown, null))));
};

Select.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(_theme.SIZES_TYPES),
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
var _default = Select;
exports["default"] = _default;